import React from "react";
import styled from "styled-components";

const PageContainer = styled.div`
  font-family: "Roboto", sans-serif;
  background: #121212;
  color: #fff;
  min-height: 100vh;
  padding: 50px 20px;
`;

const ContentWrapper = styled.div`
  max-width: 1000px;
  margin: auto;
  background: #1e1e2f;
  padding: 40px;
  border-radius: 20px;
`;

const Title = styled.h2`
  font-size: 2rem;
  margin-bottom: 20px;
  color: #00d4ff;
`;

const Section = styled.div`
  margin-bottom: 25px;
`;

const SectionTitle = styled.h3`
  font-size: 1.4rem;
  margin-bottom: 10px;
  color: #00bcd4;
`;

const Text = styled.p`
  line-height: 1.7;
  font-size: 1rem;
  margin-bottom: 15px;
`;

const TermsCondition = () => {
  return (
    <PageContainer>
      <ContentWrapper>
        <Title>Terms & Conditions</Title>

        {/* ===== Legal Disclaimer Section ===== */}
        <Section>
          <Text>
            This document is an electronic record in terms of Information
            Technology Act, 2000 and rules thereunder as applicable and the
            amended provisions pertaining to electronic records in various
            statutes as amended by the Information Technology Act, 2000. This
            electronic record is generated by a computer system and does not
            require any physical or digital signatures.
          </Text>
          <Text>
            This document is published in accordance with the provisions of Rule
            3 (1) of the Information Technology (Intermediaries guidelines)
            Rules, 2011 that require publishing the rules and regulations,
            privacy policy and Terms of Use for access or usage of domain name{" "}
            <strong>https://engineercodewala.in/</strong> ("Website"), including
            the related mobile site and mobile application (hereinafter referred
            to as "Platform").
          </Text>
          <Text>
            The Platform is owned by GAURAV, a company incorporated under the
            Companies Act, 1956 with its registered office at House No 867,
            Tulsi Vihar Colony, 24 ft Dadri, 203207, Dadri, India (hereinafter
            referred to as "Platform Owner", "we", "us", "our").
          </Text>
          <Text>
            By using this Platform, you agree to the Terms of Use, Privacy
            Policy and other applicable policies published herein. These terms
            may be updated from time to time, and it is your responsibility to
            review them periodically.
          </Text>
          <Text>
            All disputes are subject to the exclusive jurisdiction of the courts
            in Dadri, Uttar Pradesh, India.
          </Text>
        </Section>

        {/* ===== Privacy Policy Section ===== */}
        <Title>Privacy Policy</Title>

        <Section>
          <SectionTitle>1. Information We Collect</SectionTitle>
          <Text>
            When you register or purchase services, we collect your name, email,
            phone number, and payment details (via PhonePe). We may also collect
            browsing activity to improve user experience.
          </Text>
        </Section>

        <Section>
          <SectionTitle>2. How We Use Your Data</SectionTitle>
          <Text>
            Your data is used to process payments, deliver purchased products,
            and provide development services. We may also send updates and
            promotional emails with your consent.
          </Text>
        </Section>

        <Section>
          <SectionTitle>3. Payment Security</SectionTitle>
          <Text>
            All payments are processed through the PhonePe gateway. We do not
            store your full payment credentials. PhonePe’s own security and
            privacy policies apply to your transactions.
          </Text>
        </Section>

        <Section>
          <SectionTitle>4. Data Sharing</SectionTitle>
          <Text>
            We do not sell or trade your personal data. Information may be
            shared only with trusted third-party service providers for order
            fulfillment or legal compliance.
          </Text>
        </Section>

        <Section>
          <SectionTitle>5. Your Rights</SectionTitle>
          <Text>
            You may request account deletion, update your information, or opt
            out of promotional communication anytime by contacting support.
          </Text>
        </Section>
      </ContentWrapper>
    </PageContainer>
  );
};

export default TermsCondition;
